enum TimecodeMode {
    DURATION  = 'DURATION',
    REMAINING = 'REMAINING'
}

export default TimecodeMode;